import React from 'react';

// needed for dynamic group bar rendering
const GroupsContext = React.createContext({
    maxGroup: 0,
    groupTimelines: {},
    groupKeys: [],
    cmcs: [],
});

const Severities = ['severity = 1', 'severity = 2', 'severity = 3', 'severity = 4'];

export {
    GroupsContext,
    Severities,
};
